<glxy-page-toolbar class="filter-container">
  <mat-menu #actions="matMenu">
    <ng-container *ngIf="sortSelection$ | async as sortSelection">
      <button (click)="sortActions(pipelineField.POTENTIAL)" [disabled]="sortSelection.potentialRevenue" mat-menu-item>
        {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.SORT_ACTIONS.POTENTIAL_REVENUE' | translate }}
      </button>
      <button
        (click)="sortActions(pipelineField.EXPECTED_CLOSE)"
        [disabled]="sortSelection.expectedCloseDate"
        mat-menu-item
      >
        {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.SORT_ACTIONS.EXPECTED_CLOSE_DATE' | translate }}
      </button>
      <button
        (click)="sortActions(pipelineField.ACTUAL_CLOSE)"
        [disabled]="sortSelection.actualCloseDate"
        mat-menu-item
      >
        {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.SORT_ACTIONS.ACTUAL_CLOSE_DATE' | translate }}
      </button>
      <button
        (click)="sortActions(pipelineField.LAST_CONNECTED)"
        [disabled]="sortSelection.lastConnected"
        mat-menu-item
      >
        {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.SORT_ACTIONS.LAST_CONNECTED_DATE' | translate }}
      </button>
      <button
        (click)="sortActions(pipelineField.LAST_ACTIVITY)"
        [disabled]="sortSelection.lastSalesActivity"
        mat-menu-item
      >
        {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.SORT_ACTIONS.LAST_SALES_ACTIVITY' | translate }}
      </button>
      <button (click)="sortActions(pipelineField.OPPORTUNITY)" [disabled]="sortSelection.name" mat-menu-item>
        {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.SORT_ACTIONS.NAME' | translate }}
      </button>
      <button (click)="sortActions(pipelineField.CREATED)" [disabled]="sortSelection.createdDate" mat-menu-item>
        {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.SORT_ACTIONS.CREATED_DATE' | translate }}
      </button>
      <button (click)="sortActions(pipelineField.ASSIGNED_DATE)" [disabled]="sortSelection.assignedDate" mat-menu-item>
        {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.SORT_ACTIONS.ASSIGNED_DATE' | translate }}
      </button>
      <button (click)="sortActions(pipelineField.MEDDIC)" [disabled]="sortSelection.meddic" mat-menu-item>
        {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.SORT_ACTIONS.QUALIFICATION' | translate }}
      </button>
    </ng-container>
  </mat-menu>
  <button [matMenuTriggerFor]="actions" mat-button>
    <mat-icon>sort</mat-icon>
    {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.SORT' | translate }}
  </button>
  <button (click)="changeSortDirection()" mat-button>
    <mat-icon>{{ sortDirectionIcon$ | async }}</mat-icon>
  </button>
  <ng-container *ngIf="pipelines$ | async as pipelines">
    <ng-container *ngIf="currentPipeline$ | async as currentPipeline">
      <button [matMenuTriggerFor]="pipelineMenu" mat-stroked-button class="pipeline-selector">
        {{ currentPipeline.name }}
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #pipelineMenu="matMenu">
        <ng-container *ngFor="let pipeline of pipelines">
          <button
            (click)="changeSelectedPipeline(pipeline.id)"
            [disabled]="currentPipeline.id === pipeline.id"
            mat-menu-item
          >
            {{ pipeline.name }}
          </button>
        </ng-container>
        @if (displayManagePipelineFeature && hasAccessToPipelineSettings$ | async) {
          <mat-divider></mat-divider>
          <button (click)="openPipelineSettings()" mat-menu-item>
            <div class="pipeline-settings-link">
              {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.MANAGE_PIPELINES' | translate }}
            </div>
          </button>
        }
      </mat-menu>
    </ng-container>
  </ng-container>
  <sales-ui-pipeline-board-filter-chips></sales-ui-pipeline-board-filter-chips>

  <sales-ui-pipeline-saved-filters class="saved-filter-menu"></sales-ui-pipeline-saved-filters>
</glxy-page-toolbar>
<div cdkDropListGroup class="pipeline-container">
  <div *ngIf="stages$ | async as stages" class="content-display">
    <ng-container *ngFor="let stage of stages">
      <div class="stage-header">
        <ng-container *ngIf="stage.stageId !== stages[0].stageId">
          <div class="hide-gap"></div>
          <div class="line1"></div>
          <div class="line2"></div>
        </ng-container>
        <ng-container *ngIf="statsMap.get(stage.stageId) | async as stats">
          <div class="first-stage-name-row">
            <div [matTooltip]="stage.name" class="stage-name">
              {{ stage.name }}
            </div>
            <va-badge class="stage-opp-count" color="gray">
              {{ stats.totalOpportunities }}
            </va-badge>
          </div>
          <div class="stage-revenue">
            <span>{{ stats.revenue | formatCurrency: (currency$ | async) }}</span>
            <ng-container *ngIf="stats.weightedRevenue > 0">
              <mat-icon
                [matTooltip]="
                  stage.probability * 100 +
                  ('FRONTEND.SALES_UI.PIPELINE.PIPELINE.PERCENTAGE_OF' | translate) +
                  ' ' +
                  (stats.revenue | formatCurrency: (currency$ | async))
                "
              >
                balance
              </mat-icon>
              <span>{{ stats.weightedRevenue | formatCurrency: (currency$ | async) }}</span>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div [hidden]="(opportunitiesVisibleCount$ | async) === 0" class="stage-content">
        <sales-ui-pipeline-stage
          (draggedOpportunityId)="dropOpportunity($event)"
          (selectedOpportunity)="handleOpportunitySelected($event)"
          [stage]="stage"
        ></sales-ui-pipeline-stage>
      </div>
    </ng-container>
    <uikit-empty-state
      *ngIf="(opportunitiesVisibleCount$ | async) === 0"
      [title]="'FRONTEND.SALES_UI.PIPELINE.EMPTY_PIPELINE_FILTERED_OR_NO_OPPS' | translate"
      class="empty-state-on-pipeline-board"
      iconName="announcement"
    ></uikit-empty-state>
  </div>
</div>
